import {RefObject, useRef} from "react";

import {IAmplitudeLeadFormCloseFormSnapshot} from "../tracking/amplitude/get_amplitude_lead_form_inquiry_topics_selected";

export type LeadFormCloseSnapshotGetter = () => IAmplitudeLeadFormCloseFormSnapshot | undefined;

export type LeadFormCloseSnapshotRef = RefObject<LeadFormCloseSnapshotGetter | undefined>;

export const useLeadFormCloseSnapshotRef = (): LeadFormCloseSnapshotRef => useRef<LeadFormCloseSnapshotGetter | undefined>(undefined);
import {RefObject, useRef} from "react";

import {IAmplitudeLeadFormCloseFormSnapshot} from "../tracking/amplitude/get_amplitude_lead_form_inquiry_topics_selected";

export type LeadFormCloseSnapshotGetter = () => IAmplitudeLeadFormCloseFormSnapshot | undefined;

export type LeadFormCloseSnapshotRef = RefObject<LeadFormCloseSnapshotGetter | undefined>;

export const useLeadFormCloseSnapshotRef = (): LeadFormCloseSnapshotRef => useRef<LeadFormCloseSnapshotGetter | undefined>(undefined);
